import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import tickImage from "../assets/images/double-tick.png";
import noteImage from "../assets/images/notes.png";
import plusImage from "../assets/images/plus.png";
import {
  useAddTodoMutation,
  useClearCompleteMutation,
  useGetTodosQuery,
  useUpdateAllCompleteMutation
} from "../rtk/features/api/apiSlice";
import { resetColors, setStatus } from "../rtk/features/filter/filterSlice";

export default function Header() {
  const dispatch = useDispatch();
  const [input, setInput] = useState("");
  const [request, setReuest] = useState(false);

  const { data: todos } = useGetTodosQuery(``, {
    skip: !request,
  });
  const [addTodo, { isLoading }] = useAddTodoMutation();
  const [updateAllComplete] = useUpdateAllCompleteMutation();
  const [clearComplete] = useClearCompleteMutation();

  useEffect(() => {
    setReuest(true);
  }, []);

  // all complete
  const completeHadler = () => {
    const incompleteArr = todos.filter((itm) => itm?.completed === false);
    if (incompleteArr?.length > 0) {
      incompleteArr.forEach((todo) => {
        return updateAllComplete({
          id: todo?.id,
          data: {
            id: todo?.id,
            text: todo?.text,
            completed: true,
            color: todo?.color,
          },
        });
      });
      setReuest(true);
    } else {
      setReuest(false);
      toast.warning("There is no incomplete todo !!!");
    }
  };

  // all clear complete
  const clearHeandler = () => {
    const completeArr = todos.filter((itm) => itm?.completed === true);
    if (completeArr?.length > 0) {
      completeArr.forEach((todo) => {
        return clearComplete(todo?.id);
      });
    } else {
      setReuest(false);
      toast.warning("There is no complete todo !!!");
    }
  };

  // create
  const handleInput = (e) => {
    setInput(e.target.value);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (input !== "") {
      addTodo({
        text: input,
        completed: false,
      });
      dispatch(resetColors());
      dispatch(setStatus("All"));
      setInput("");
    } else {
      toast.warning("Input empty!!!");
    }
  };

  return (
    <div>
      <form
        className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
        onSubmit={submitHandler}
      >
        <img src={noteImage} className="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          placeholder="Type your todo"
          className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
          value={input}
          onChange={handleInput}
        />
        <button
          disabled={isLoading}
          type="submit"
          className={`appearance-none w-8 h-8 bg-[url('${plusImage}')] bg-no-repeat bg-contain`}
        ></button>
      </form>

      <ul className="flex justify-between my-4 text-xs text-gray-500">
        <li className="flex space-x-1 cursor-pointer" onClick={completeHadler}>
          <img className="w-4 h-4" src={tickImage} alt="Complete" />
          <span>Complete All Tasks</span>
        </li>
        <li className="cursor-pointer" onClick={clearHeandler}>
          Clear completed
        </li>
      </ul>
    </div>
  );
}
